function MultimediaContentItem({item, index}: any) {
  return (
    <div
      key={index}
      style={{maxWidth: '100%', overflowX: 'auto', width: '100%'}}
      dangerouslySetInnerHTML={{__html: String(item.contentText)}}
    />
  )
}

export default MultimediaContentItem
